/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {MonkeysGoldBigWinCountUp} from "./MonkeysGoldBigWinCountUp";
import {MonkeysGoldBigWinView} from "./MonkeysGoldBigWinView";
import {Timeline, TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";

export class MonkeysGoldBigWinController extends StepCountUpBigWinController {

    private _gameView:MonkeysGoldBigWinView;
    private _winCountUp:MonkeysGoldBigWinCountUp;
    private _mode:string;
    private _countUpToValue:number;

    constructor(indexes:[number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : false,
            skippableOnEachLevel : true
        });

        this._gameView = MonkeysGoldGameModuleConfig.monkeysGoldBigWinView = new MonkeysGoldBigWinView();
        this._winCountUp = new MonkeysGoldBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5, 150);
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData) {
        this._mode = data.mode;
        super.parseFeatureGameData(data);
    }

    protected startWinPresentation():void {
        if(this._mode == GameMode.FREESPIN || this._mode == GameMode.FREESPIN_AVALANCHE) {
            (<INolimitAudioPlayer>SlotGame.sound).fadeTrack({
                name : MonkeysGoldSoundConfig.instance.BONUS_GAME_MUSIC,
                duration : 500,
                from : 1,
                to : 0
            });
        } else {
            (<INolimitAudioPlayer>SlotGame.sound).fadeTrack({
                name : MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC[0],
                duration : 500,
                from : 1,
                to : 0
            });
        }
        super.startWinPresentation();
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._gameView.getBigWinLevelAnimation(this._winRatios[level]);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        this._gameView.triggerMonkeyHideTL(duration);
        this._countUpToValue = to;
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._gameView.playEndingAnimation(this._winRatios[this._winLevel]);

        SlotGame.winFieldController.showWinField();

        if(this._mode == GameMode.FREESPIN || this._mode == GameMode.FREESPIN_AVALANCHE) {
            (<INolimitAudioPlayer>SlotGame.sound).fadeTrack({
                name : MonkeysGoldSoundConfig.instance.BONUS_GAME_MUSIC,
                duration : 2000,
                from : 0,
                to : 1
            });
        } else {
            (<INolimitAudioPlayer>SlotGame.sound).fadeTrack({
                name : MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC[0],
                duration : 2000,
                from : 0,
                to : 1
            });
        }
        const delayTL:TimelineLite = new TimelineLite();
        delayTL.add(() => this._winCountUp.abort(this._countUpToValue, isAborted), "+=0.5");
    }
}